module.exports = __webpack_public_path__ + "static/img/logoEn-1.3b9ac45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoEn-1.png
// module id = F0bJ
// module chunks = 51